import { Routes } from '@angular/router';
import { InscriptionComponent } from './components/inscription/inscription.component';
import { RenewPasswordComponent } from './components/renew-password/renew-password.component';

export const AuthRouting: Routes = [
  // {
  //   path: 'signin',
  //   component: ConnexionPageComponent // TODO
  // },
  {
    path: 'signup',
    component: InscriptionComponent
  },
  {
    path: 'renew',
    component: RenewPasswordComponent
  }
];
